var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"ui-radio-with-text"},[_c('div',{staticClass:"ui-radio-with-text__radio"},[_c('ui-input-radio',{attrs:{"name":_vm.name},model:{value:(_vm.checkedInner),callback:function ($$v) {_vm.checkedInner=$$v},expression:"checkedInner"}})],1),_c('div',{staticClass:"ui-radio-with-text__text",domProps:{"textContent":_vm._s(_vm.text)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }